import { selectAllLocations } from '@user/store/locations/slice'
import * as React from 'react'
import { useSelector } from 'react-redux'
import { LocationCard } from './LocationCard'
import { NoResultsCard } from '@sales-center/components'

export const LocationList: React.FC = () => {
  const locations = useSelector(selectAllLocations)

  return locations.length == 0 ? (
    <NoResultsCard label="No locations found" />
  ) : (
    <>
      {locations.map((l) => (
        <LocationCard key={l.id} location={l} />
      ))}
    </>
  )
}
